var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFriendSignup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.18,
    height: 27.623,
    viewBox: "0 0 31.18 27.623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_124974",
    x: 14.348,
    y: 9.906,
    width: 14.284,
    height: 9.972,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_1318",
    x: 16.833,
    y: 0,
    width: 9.282,
    height: 9.282,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_124975",
    x: 0,
    y: 17.183,
    width: 14.252,
    height: 10.161,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_1319",
    x: 2.485,
    y: 7.32,
    width: 9.282,
    height: 9.282,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_124976",
    x: 15.335,
    y: 17.815,
    width: 9.091,
    height: 9.808,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#5142fc",
    result: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "friend_signup",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124974-2",
    "data-name": "Path 124974",
    d: "M65.818,42.159A4.949,4.949,0,0,0,60.895,37.8h-3.45a4.944,4.944,0,0,0-4.892,4.359l-.47,4.014a1.008,1.008,0,0,0,.784,1.129c.47.094.941.188,1.443.251l3.669-2.76a2.519,2.519,0,0,1,3.889,1.192l.6,1.788c1.066-.125,2.1-.251,3.1-.47a1.035,1.035,0,0,0,.784-1.129Z",
    transform: "translate(-37.727 -27.894)",
    fill: "#5142fc"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_124974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124974-3",
    "data-name": "Path 124974",
    d: "M65.818,42.159A4.949,4.949,0,0,0,60.895,37.8h-3.45a4.944,4.944,0,0,0-4.892,4.359l-.47,4.014a1.008,1.008,0,0,0,.784,1.129c.47.094.941.188,1.443.251l3.669-2.76a2.519,2.519,0,0,1,3.889,1.192l.6,1.788c1.066-.125,2.1-.251,3.1-.47a1.035,1.035,0,0,0,.784-1.129Z",
    transform: "translate(-37.73 -27.89)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1318-2",
    "data-name": "Ellipse 1318",
    cx: 4.641,
    cy: 4.641,
    r: 4.641,
    transform: "translate(16.833 0)",
    fill: "#5142fc"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Ellipse_1318)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1318-3",
    "data-name": "Ellipse 1318",
    cx: 4.641,
    cy: 4.641,
    r: 4.641,
    transform: "translate(16.83 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124975-2",
    "data-name": "Path 124975",
    d: "M11.327,62.5H7.878a4.975,4.975,0,0,0-4.923,4.359l-.47,4.014A1.035,1.035,0,0,0,3.268,72a29.505,29.505,0,0,0,6.335.659A29.718,29.718,0,0,0,15.937,72a1.035,1.035,0,0,0,.784-1.129l-.47-4.014A4.949,4.949,0,0,0,11.327,62.5Z",
    transform: "translate(-2.477 -45.317)",
    fill: "#5142fc"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_124975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124975-3",
    "data-name": "Path 124975",
    d: "M11.327,62.5H7.878a4.975,4.975,0,0,0-4.923,4.359l-.47,4.014A1.035,1.035,0,0,0,3.268,72a29.505,29.505,0,0,0,6.335.659A29.718,29.718,0,0,0,15.937,72a1.035,1.035,0,0,0,.784-1.129l-.47-4.014A4.949,4.949,0,0,0,11.327,62.5Z",
    transform: "translate(-2.48 -45.32)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1319-2",
    "data-name": "Ellipse 1319",
    cx: 4.641,
    cy: 4.641,
    r: 4.641,
    transform: "translate(2.485 7.32)",
    fill: "#5142fc"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Ellipse_1319)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1319-3",
    "data-name": "Ellipse 1319",
    cx: 4.641,
    cy: 4.641,
    r: 4.641,
    transform: "translate(2.48 7.32)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124976-2",
    "data-name": "Path 124976",
    d: "M61.4,64.949a.631.631,0,0,0-.972-.314l-4.2,3.167a.646.646,0,0,0,.188,1.129l1.192.376a8.7,8.7,0,0,1-3.45,4.422.286.286,0,0,0,.094.5,6.148,6.148,0,0,0,6.836-3.889l1.223.376a.626.626,0,0,0,.784-.815Z",
    transform: "translate(-38.71 -46.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_124976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124976-3",
    "data-name": "Path 124976",
    d: "M61.4,64.949a.631.631,0,0,0-.972-.314l-4.2,3.167a.646.646,0,0,0,.188,1.129l1.192.376a8.7,8.7,0,0,1-3.45,4.422.286.286,0,0,0,.094.5,6.148,6.148,0,0,0,6.836-3.889l1.223.376a.626.626,0,0,0,.784-.815Z",
    transform: "translate(-38.71 -46.7)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_125237",
    "data-name": "Path 125237",
    d: "M15.908,12.817a.636.636,0,0,1-.452-.185L14.183,11.36a.639.639,0,0,1,.9-.9l.821.827L18,9.183a.639.639,0,1,1,.9.9L16.36,12.633A.636.636,0,0,1,15.908,12.817Z",
    transform: "translate(12.087 -2.598)",
    fill: "#1e9d60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendSignup);
export default __webpack_public_path__ + "static/media/friend-signup.fa9ed1272a842dc87aefc2614c3b44a0.svg";
export { ForwardRef as ReactComponent };